export default __webpack_public_path__ + "static/skroutz-2adad2b7390efe0305618a92b5f3102f.svg";